import { render, staticRenderFns } from "./platBroad.vue?vue&type=template&id=038a4e4b&scoped=true"
import script from "./platBroad.vue?vue&type=script&lang=js"
export * from "./platBroad.vue?vue&type=script&lang=js"
import style0 from "./platBroad.vue?vue&type=style&index=0&id=038a4e4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038a4e4b",
  null
  
)

export default component.exports